import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import convertJalaliToMiladi from "../../utilities/functions/convertJalaliToMiladi";
import { useSelector } from "react-redux";
import haveAccess from "../../utilities/functions/haveAccess";
import { MoreVert } from "@mui/icons-material";
import { ReactComponent as ArrowRightAltIcon } from "./../../assets/images/icons/Google SVGs/arrow_right_alt.svg";

const TurnSummaryCard = (props) => {
  const { token, roles } = useSelector((state) => state.user);
  const tokenLocal = localStorage.getItem("token");

  const headers = {
    Authorization: "Bearer " + (token ? token : tokenLocal),
  };

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [clicked, setClicked] = useState(false);
  const [visitComments, setVisitComments] = useState([]);
  const [visitNewComment, setVisitNewComment] = useState([]);

  const getTurnComments = () => {
    setVisitComments([]);
    axios
      .get(
        serverConfig.server.url +
          apiConfig.api.getAPIs.eventDetail +
          props.turnID +
          "/comments",
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setVisitComments(response.data.data.comments_list);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const changeEventStatusAPI = (status, date, time) => {
    axios
      .post(
        serverConfig.server.url +
          apiConfig.api.updateAPIs.updateEvent +
          props.turnID,
        {
          start: convertJalaliToMiladi(date) + " " + time,
          status: status,
        },
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          props.onChange("Updated!");
          toast.success(response.data.message);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const addNewComment = () => {
    axios
      .post(
        serverConfig.server.url + apiConfig.api.addAPIs.addComment,
        {
          user_id: props.doctorID,
          model_id: props.turnID,
          model_name: "event",
          content: visitNewComment,
        },
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          getTurnComments();
          setVisitNewComment("");
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  return (
    <div>
      <div
        className={`card ${
          props.clicked ? "border-gray-600 border-1" : "border-gray-300"
        }`}
        onClick={() => {
          setClicked(props.clicked);
        }}
      >
        <div className="card-header d-flex fs-14 fw-normal p-2 border-0 align-items-center rounded color-bootstrap-gray-700 background-bootstrap-gray-100 m-2">
          <span className="d-flex col-auto px-0">
            {props.date && <span className="me-2">{props.date}</span>}
            {props.day && <span className="me-2">{props.day}</span>}
            {props.time && <span className="me-2">{props.time}</span>}
          </span>
          <div className="col-auto ms-auto fs-12 px-12px py-2px border-radius-4 background-bootstrap-gray-200">
            <span>{props.lastStatus}</span>
          </div>
        </div>
        <div className="card-body p-2 fs-14 fw-regular d-flex row">
          <div className="col">
            <div className="d-flex mb-2 ">
              <span className="fw-medium color-bootstrap-gray-800">
                بیمار:&nbsp;
              </span>
              <span>
                {props.patientFirstName} {props.patientLastName}
              </span>
            </div>
            <div className="d-flex mb-2">
              <span className="fw-medium color-bootstrap-gray-800">
                تلفن:&nbsp;
              </span>
              <a
                className="text-decoration-none"
                href={"tel:" + props.patientTel}
              >
                {props.patientTel}
              </a>
            </div>
            <div className="d-flex mb-2">
              <span className="fw-medium color-bootstrap-gray-800">
                پزشک:&nbsp;
              </span>
              <span>
                {props.doctorTitle} {props.doctorFirstName}{" "}
                {props.doctorLastName}
              </span>
            </div>
            <div className="d-flex mb-2">
              <span className="fw-medium color-bootstrap-gray-800">
                مرکز درمانی:&nbsp;
              </span>
              <span>{props.placeTitle}</span>
            </div>
            <div className="d-flex mb-2">
              <span className="fw-medium color-bootstrap-gray-800">
                دپارتمان:&nbsp;
              </span>
              <span>{props.departmentTitle}</span>
            </div>
            <div className="d-flex mb-2">
              <div className="me-2 py-2px rounded-pill fs-12 fw-normal px-12px background-bootstrap-gray-200">
                <span>{props.turnType}</span>
              </div>
              {/* <div className="me-2 py-2px rounded-pill fs-12 fw-regular bg-iso-green-100 px-12px">
                <span>{props.payment}</span>
              </div> */}
              {props.byWho ? (
                <div className="me-2  py-2px rounded-pill fs-12 fw-normal px-12px background-bootstrap-gray-200">
                  <span>{props.byWho}</span>
                </div>
              ) : (
                ""
              )}
              {props.commentCount > 0 && (
                <span
                  class=" me-2  py-2px rounded-pill fs-12 fw-normal px-12px bg-warning"
                  onClick={getTurnComments}
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target={`#privateMessageModal${props.turnID}`}
                >
                  {props.commentCount + " یادداشت"}
                  <span class="visually-hidden">unread messages</span>
                </span>
              )}
            </div>
          </div>
          <div className="col-auto">
            <div className="dropdown ms-auto color-bootstrap-gray-700">
              <MoreVert
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />

              <ul className="dropdown-menu">
                {haveAccess(roles, "turnSummary_comment_show") &&
                  props.actionAccess && (
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={getTurnComments}
                        data-bs-toggle="modal"
                        data-bs-target={`#privateMessageModal${props.turnID}`}
                      >
                        نوشتن نظر
                      </button>
                    </li>
                  )}
                {/* <li>
                  <a className="dropdown-item" href="#">
                    تغییر زمان نوبت
                  </a>
                </li> */}
                <li>
                  <a className="dropdown-item" href={"tel:" + props.patientTel}>
                    تماس با مراجعه کننده
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="d-flex mt-2">
            <div
              onClick={() => {
                navigate(`/turn?${"id=" + props.turnID}`);
              }}
              className="btn bg-iso-blue-300 color-iso-white col fs-14 fw-normal border-radius-8 d-flex align-items-center justify-content-center"
            >
              جزئیات
            </div>

            <div
              onClick={() => {
                navigate(
                  `/booking?pl=${props.placeID}&dep=${props.departmentID}&dr=${props.doctorID}`
                );
              }}
              className="btn btn-secondary col ms-2 py-2 fs-14 fw-mediam border-radius-8 d-flex align-items-center justify-content-center"
            >
              نوبت مجدد
            </div>
            {haveAccess(roles, "turnSummary_changetoDone") &&
              props.actionAccess && (
                <div
                  className="btn border-iso-blue-300 color-iso-blue-300 col ms-2 fs-14 fw-mediam border-radius-8  d-flex align-items-center justify-content-center "
                  onClick={() => {
                    changeEventStatusAPI("done", props.date, props.time);
                  }}
                >
                  ویزیت شد
                </div>
              )}
          </div>
        </div>
      </div>
      {/* Private Messages Modal */}
      <div
        className="modal fade"
        id={`privateMessageModal${props.turnID}`}
        tabIndex="-1"
        aria-labelledby="privateMessageModallabel"
        aria-hidden="true"
        onClick={() => {
          // Your custom logic when the modal is closed
          // setSpecialtySearch("");
        }}
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2 justify-content-start color-bootstrap-gray-800">
              <ArrowRightAltIcon
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <span>یادداشت های خصوصی</span>
            </div>
            <div className="modal-body">
              {/* Specialty Dropdown */}
              <div className="d-flex flex-column align-items-start">
                {visitComments.length >= 1 &&
                  visitComments.map((comment, index) => (
                    <span
                      className="card d-flex p-0 border-0 w-100 align-items-start my-2 py-2 background-bootstrap-gray-100"
                      key={index}
                    >
                      <div className=" d-flex row w-100 m-0">
                        <div className="d-flex col col-12 color-bootstrap-gray-600 mb-1">
                          {comment.creator_first_name +
                            " " +
                            comment.creator_last_name}
                        </div>
                        <div className="d-flex col col-auto me-auto">
                          {comment.content}
                        </div>
                        <div className="d-flex col col-auto fs-12 color-bootstrap-gray-600">
                          {comment.time}
                        </div>
                        <div className="d-flex col col-auto fs-12 color-bootstrap-gray-600">
                          {comment.date}
                        </div>
                      </div>
                    </span>
                  ))}
                {visitComments.length === 0 && (
                  <span className="card border-0 w-100 d-flex align-items-center p-2 background-bootstrap-gray-100 color-bootstrap-gray-600">
                    یادداشتی وجود ندارد
                  </span>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <textarea
                className="form-control mt-2"
                aria-label="With textarea"
                placeholder="یادداشت خود را برای نوبت وارد کنید"
                value={visitNewComment ? visitNewComment : ""}
                onChange={(e) => {
                  setVisitNewComment(e.target.value);
                }}
              />
              <div
                className={`btn w-100 rounded-3 p-2 mt-2 btn-primary fw-medium color-bootstrap-gray-100 bg-iso-blue-300${
                  visitNewComment.length >= 3 &&
                  visitNewComment.length <= 800 &&
                  !loading
                    ? ""
                    : " disabled"
                }`}
                onClick={() => {
                  addNewComment();
                }}
              >
                افزودن یادداشت
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TurnSummaryCard.propTypes = {
  date: PropTypes.string,
  day: PropTypes.string,
  time: PropTypes.string,
  turnStatus: PropTypes.string,
  patientName: PropTypes.string,
  patientTel: PropTypes.string,
  doctorName: PropTypes.string,
  department: PropTypes.string,
  subDepartment: PropTypes.string,
  turnType: PropTypes.string,
  payment: PropTypes.string,
  byWho: PropTypes.string,
  doctorID: PropTypes.number,
  departmentID: PropTypes.number,
  placeID: PropTypes.number,
};

export default TurnSummaryCard;
